import { render, staticRenderFns } from "./SchoolList.vue?vue&type=template&id=3adeed25&"
import script from "./SchoolList.js?vue&type=script&lang=js&"
export * from "./SchoolList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports